

import $ from 'jquery';

// Flip image and caption for every second page builder block
$('.page-builder').each((page) => {
    $('.page-builder__item--image:even', page)
        .addClass('page-builder__item--rev');
});



// WEBPACK FOOTER //
// ./source/scripts/components/page-builder.js